import { useTranslate } from "@educaplay/core/hooks";
import { useState } from 'react';
import IconButton from '../IconButton';
import FinishIcon from './FinishIcon';

export default function FinishButton({ onClick }) {
    const t = useTranslate();

    const [hasBeenClicked, setHasBeenClicked] = useState(false);

    const handleClick = () => {
        setHasBeenClicked(true);
        onClick();
    }

    return (
        <IconButton 
            Icon={FinishIcon}
            onClick={handleClick}
            label={t("specific.finish")}
            disabled={hasBeenClicked}
            variant="primary"
            lectormsg={t("specific.finish")}
             
        />
     
       
    )
}
